const isAbsoluteUrl = (url) => url.startsWith("http://") || url.startsWith("https://");
export {
  isAbsoluteUrl
};
//# sourceMappingURL=is-absolute-url.js.map
